import React, { FunctionComponent } from 'react';
import { SbBlokData } from '@storyblok/react';

import { ComparisonCards } from '@savebetter/components';

import { PageSectionBlok, PageSectionProps } from './PageSection';
import { PageSectionHeader } from './PageSectionHeader';
import { Section } from './Section';

interface Card extends SbBlokData {
  left: string;
  right: string;
}

interface Blok extends PageSectionBlok {
  title: string;
  leftColumnTitle: string;
  rightColumnTitle: string;
  cards: Card[];
}

interface WhySaveBetterProps extends PageSectionProps {
  blok: Blok;
}

export const WhyRaisin: FunctionComponent<React.PropsWithChildren<WhySaveBetterProps>> = ({
  blok,
  sectionClassName
}) => {
  const {
    hasBackground,
    hasBorder,
    title,
    leftColumnTitle,
    rightColumnTitle,
    cards = [],
    hasPaddingTop,
    hasPaddingBottom
  } = blok;
  const vsItems = cards.map(({ left, right }) => ({
    left,
    right
  }));

  return (
    <Section
      width="md"
      hasBackground={hasBackground}
      hasBorder={hasBorder}
      className={sectionClassName}
      blok={blok}
      hasPaddingBottom={hasPaddingBottom}
      hasPaddingTop={hasPaddingTop}
    >
      <PageSectionHeader>{title}</PageSectionHeader>
      <ComparisonCards leftLabel={leftColumnTitle} rightLabel={rightColumnTitle} vsItems={vsItems} />
    </Section>
  );
};
